import React, { useState, useEffect } from 'react';
import NameIcon from '@/components/NameIcon';
import { Icon } from '@b-design/fusion';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CategoryItem from './component/categoryItem';
import $i18n from '@/i18n';
import store from '@/store';
import './index.less';

const LeftList: React.FC = (props) => {
  const { checkItem, setCheckItem } = props;
  const { channelCode, spaceId } = getQueryStringArgs();
  const [channelInfo, setChannelInfo] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [spaceRoleState] = store.useModel('spaceRole');

  /**
   * 初始化列表数据请求
   */
  const getCategoryList = () => {
    Requests.post('/rest/intercnn/channel/category/list', { channelCode }).then((res) => {
      if (res) {
        res.sort((a, b) => {
          return a.sort - b.sort;
        });
        setCategoryList(res);
        res.map((i) => (i.id = i.categoryId));
      }
    });
  };

  useEffect(() => {
    Requests.post('/rest/intercnn/channel/category/list', { channelCode }).then((res) => {
      if (res) {
        res.sort((a, b) => {
          return a.sort - b.sort;
        });
        setCategoryList(res);
        res.map((i) => (i.id = i.categoryId));
        setCheckItem(res[0]?.id);
      }
    });
    if (!spaceId) {
      return;
    };
    Requests.get('/rest/intercnn/publishChannel/pageQuery', {
      draftStatus: 'ONLINE',
      currentPage: 1,
      pageSize: 30,
      spaceId,
      innerCode: channelCode,
      belongSpaceId: spaceRoleState?.belongSpaceId || '',
    }).then((res) => {
      setChannelInfo(res.list[0]);
    });
  }, []);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    Requests.post('/rest/intercnn/channel/category/reorder', {
      categoryId: removed?.id,
      channelCode,
      order: endIndex,
    }).then((res) => {
      getCategoryList();
    });
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    reorder(categoryList, result.source.index, result.destination.index);
  };

  return (
    <div className="leftList">
      <div className="list-channel">
        {channelInfo?.iconPublicUrl ? (
          <img className="list-icon" src={channelInfo?.iconPublicUrl} />
        ) : (
          <NameIcon
            name={channelInfo?.name}
            styles={{ width: '33px', height: '33px' }}
            shape="square"
          />
        )}
        <div className="channel-name">{channelInfo?.name}</div>
      </div>
      <DragDropContext onDragEnd={onDragEnd} key={Math.random() * 1000000}>
        <Droppable droppableId="list" direction="vertical">
          {(provided, snapshot) => (
            <div ref={provided.innerRef} className="category-list" {...provided.droppableProps}>
              {categoryList.map((item, index) => (
                <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                  {(provided, snapshot) => (
                    <div
                      className={`category-item ${checkItem === item.id ? 'list-active' : ''}`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <CategoryItem
                        value={item}
                        setCheckItem={setCheckItem}
                        getCategoryList={getCategoryList}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}

              <div className={`category-item ${checkItem === -1 ? 'list-active' : ''}`}>
                <div className="list-item">
                  <div className="item-title" onClick={() => setCheckItem(-1)}>
                    <Icon type="draggable" size="small" />
                    <div className="item-title-name">
                      {$i18n.get({
                        id: 'aopf.pages.miniAppStore.setting.category.list.unFiled',
                        dm: '未分类',
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default LeftList;
